module.exports = __webpack_public_path__ + "resources/img/img-danbiAi-m-jp.c5ad15f495013e5e35dff6f78da10ed4.png";